module.exports = __webpack_public_path__ + "assets/images/logo-votolegal.png?9607528bd8ee9e6f5a89367625f46c80";


//////////////////
// WEBPACK FOOTER
// ./_source/images/logo/logo-votolegal.png
// module id = 602
// module chunks = 0